var _this = this;

import * as tslib_1 from "tslib";
import { ANALYTICS_API_PUBLIC_PATH } from "../../api";
import axios from "../../utils/axios-client";
export var apiDebugLogin = function apiDebugLogin() {
  return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var response, _a, response;

    return tslib_1.__generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , axios.get(ANALYTICS_API_PUBLIC_PATH + "/debug/login")];

        case 1:
          response = _b.sent();
          return [2
          /*return*/
          , response.status];

        case 2:
          _a = _b.sent();
          response = _a.response;
          return [2
          /*return*/
          , response.status];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
};